import { render, staticRenderFns } from "./QAlert.vue?vue&type=template&id=5712df3f&scoped=true"
import script from "./QAlert.vue?vue&type=script&lang=js"
export * from "./QAlert.vue?vue&type=script&lang=js"
import style0 from "./QAlert.vue?vue&type=style&index=0&id=5712df3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712df3f",
  null
  
)

/* custom blocks */
import block0 from "./QAlert.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports